import { useEffect } from "react";

export function useTabFocus(onFocus: () => void) {
  useEffect(() => {
    function handleVisibilityChange() {
      if (!document.hidden) {
        onFocus(); // tab became visible
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [onFocus]);
}